import { render, staticRenderFns } from "./Tpcheck-table.vue?vue&type=template&id=cf044cf4"
import script from "./Tpcheck-table.vue?vue&type=script&lang=js"
export * from "./Tpcheck-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports